import styled from 'styled-components'

import theme from '../../theme'

const WrapperContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`

interface borderContainerProps {
  width?: string
  hasCornerBorder?: boolean
}
const BorderContainer = styled.div<borderContainerProps>`
  height: 0.8em;
  width: ${(props) => props.width};
  border-bottom: 1px solid ${theme.colors.gray4};
  ${(props) => (props.hasCornerBorder ? 'border-left: 1px solid ' + theme.colors.gray4 + ';' : '')}
`

interface labelSpanProps {
  textColor?: string
}
const LabelSpan = styled.span<labelSpanProps>`
  font-weight: ${theme.fontWeights.semiBold};
  font-size: ${theme.fontSizes.medium};
  color: ${(props) => props.textColor ?? theme.colors.brandPrimary6};
  padding: 0 6px;
  white-space: nowrap;
`

export { WrapperContainer, BorderContainer, LabelSpan }
